var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagUnitedArabEmirates({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 2.77734H5V7.77734H20V4.99957C20 4.4102 19.7659 3.84496 19.3491 3.42822C18.9324 3.01147 18.3671 2.77734 17.7778 2.77734Z",
    fill: "#068241"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.77734H20V12.2218H5V7.77734Z",
    fill: "#EEEEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17.2227H17.7778C18.3671 17.2227 18.9324 16.9885 19.3491 16.5718C19.7659 16.155 20 15.5898 20 15.0004V12.2227H5V17.2227Z",
    fill: "#141414"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22222 2.77734C1.63285 2.77734 1.06762 3.01147 0.650874 3.42822C0.234126 3.84496 0 4.4102 0 4.99957L0 14.9996C0 15.5889 0.234126 16.1542 0.650874 16.5709C1.06762 16.9877 1.63285 17.2218 2.22222 17.2218H5V2.77734H2.22222Z",
    fill: "#EC2028"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUnitedArabEmirates);
export default __webpack_public_path__ + "static/media/flag-united-arab-emirates.8190158764e77034d16c1ecd7cfe1cd2.svg";
export { ForwardRef as ReactComponent };